import { h } from 'preact'
import { modelTypes } from 'app/constants'
import useSSR from '@core/hooks/useSSR'
import translate from 'core/hooks/useResource'
import FooterColumns from './FooterColumns'
import FooterPartners from './FooterPartners'
import FooterCopyright from './FooterCopyright'

export default function FooterContainer() {
	const {
		footer,
		footerCopyright,
		footerLinks,
		footerTopics,
		socialSettings,
		newsletterSettings,
	} = useSSR([
		modelTypes.footer,
		modelTypes.footerCopyright,
		modelTypes.footerTopics,
		modelTypes.footerLinks,
		modelTypes.socialSettings,
		modelTypes.newsletterSettings,
	])

	const { storeName, workingLanguageId, storePhone, storeEmail, storeAddress } = footer

	const { newsletterEmail, allowToUnsubscribe } = newsletterSettings

	return (
		<footer className="site-footer">
			<div className="inner">
				<FooterColumns
					storeName={storeName}
					email={storeEmail}
					phone={storePhone}
					address={storeAddress}
					topics={footerTopics}
					links={footerLinks}
					socialSettings={socialSettings}
				/>

				<FooterPartners />
				<FooterCopyright
					copyright={footerCopyright.copyright}
					ecommmerce={footerCopyright.footerEcommerce}
					byWombit={footerCopyright.byWombit}
					hidePoweredByNopCommerce={footer.hidePoweredByNopCommerce}
				/>
			</div>
		</footer>
	)
}
